import React from 'react'

import styles from './Details.module.css'

export const Attachments = function ViewDetailsAttachments({ urls }) {
  return (
    <div className={styles.attachments}>
      {urls.map(url =>
        url ? (
          <img key={url} src={url} alt="Attachment Thumbnail" width={32} />
        ) : (
          <span className={styles.fileIcon} />
        )
      )}
    </div>
  )
}

export const User = function ViewDetailsUser({ user }) {
  const { email, name } = user

  return (
    <div className={styles.user}>
      <div className={styles.avatar} />
      <div className={styles.userInfo}>
        <p>{name || email}</p>
        {name && email && <p className={styles.userSubtitle}>{email}</p>}
      </div>
    </div>
  )
}

const formatDuration = duration => {
  if (!duration) {
    return 'zero seconds'
  }

  duration = +duration

  let remaining = duration

  const days = Math.floor(remaining / (24 * 60 * 60))
  remaining -= days * 24 * 60 * 60

  const hours = Math.floor(remaining / (60 * 60))
  remaining -= hours * 60 * 60

  const minutes = Math.floor(remaining / 60)
  remaining -= minutes * 60

  const seconds = Math.round(remaining)

  let result = []

  if (days) {
    result.push(`${days} day${days === 1 ? '' : 's'}`)
  }

  if (hours) {
    result.push(`${hours} hour${hours === 1 ? '' : 's'}`)
  }

  if (minutes) {
    result.push(`${minutes} hour${minutes === 1 ? '' : 's'}`)
  }

  if (seconds) {
    result.push(`${seconds} second${seconds === 1 ? '' : 's'}`)
  }

  return result
}

const getFormattedValue = (value, airtableDataType) => {
  switch (airtableDataType) {
    case 'currency': {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      })

      return formatter.format(value)
    }
    case 'percent':
      return `${(100 * value).toFixed(0)}%`
    case 'duration':
      return formatDuration(value)
    default:
      return value
  }
}

export const FormattedNumber = function FormatterNumber({ value, column }) {
  const { airtableDataType } = column || {}
  const formattedValue = getFormattedValue(value, airtableDataType)

  return <span>{formattedValue}</span>
}
